/*
 * 功能模块的颜色变量配置
 */

import { ThemeColors } from '..';

export const createColors: ThemeColors = {
  color: {
    'create-text-primary': 'var(--create-text-primary)',
  },
  backgroundColor: {
    'create-bg-primary': 'var(--create-bg-primary)',
    'create-block-bg': 'var(--create-block-bg)',
  },
  borderColor: {
    'create-border-primary': 'var(--create-border-primary)',
  },
};
